var map = {
	"./en/about.json": "LNT/",
	"./en/newMain.json": "shfI",
	"./en/qna.json": "Pvlq",
	"./en/register.json": "ag71",
	"./en/service.json": "iIc+",
	"./ko/about.json": "SOJJ",
	"./ko/newMain.json": "gkHn",
	"./ko/qna.json": "eWGv",
	"./ko/register.json": "B5fl",
	"./ko/service.json": "jbIM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/IeC";


//////////////////
// WEBPACK FOOTER
// ./src/locales \.json$
// module id = /IeC
// module chunks = 1